import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from '../../../util/reactIntl';
import css from './Sections.module.css';
import { Icons, SecondaryButton } from '../../../components';
import sellersImg from '../../../assets/seller-img.png';
import sellerStepImg from '../../../assets/seller-step.png';
import sellerFee from '../../../assets/seller-fee.png';

import SectionFAQ from './SectionFAQ';
import routeConfiguration from '../../../routing/routeConfiguration';
import { createResourceLocatorString } from '../../../util/routes';

function SectionSellers(props) {
  const { intl, history } = props;
  return (
    <div className={css.sellersContainer}>
      <div className={css.fixedWidthContainer}>
        <h1>{intl.formatMessage({ id: 'HowItWorksPage.SectionSellers.title' })}</h1>
        <div className={css.sellersContent}>
          <div className={css.sellersInfo}>
            <div className={css.sellersInfoInner}>
              <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionSellers.subtitle1' })}</h2>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionSellers.description1' })}</p>
              <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionSellers.description2' })}</p>
            </div>
          </div>
          <div className={css.sellersImg}>
            <img src={sellersImg} alt="banner" />
          </div>
        </div>
        <div className={css.sellerSteps}>
          <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionSellers.exactStepsTitle' })}</h2>
          <div className={css.sellersContent}>
            <div className={css.sellersImg}>
              <img src={sellerStepImg} alt="banner" />
            </div>
            <div className={css.sellersInfo}>
              <div className={css.sellersInfoInner}>
                <SectionFAQ intl={intl} />
              </div>
            </div>
          </div>
        </div>
        <div className={css.sellerFeeSec}>
          <div className={css.sellerFeeInfo}>
            <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionSellers.sellersFeesTitle' })}</h2>
            <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionSellers.sellersFeesDescription' })}</p>
            <SecondaryButton 
              onClick={() => history.push(createResourceLocatorString('NewListingPage', routeConfiguration(), {}, {}))}
            >
              {intl.formatMessage({ id: 'HowItWorksPage.SectionSellers.startSelling' })}
            </SecondaryButton>
          </div>
          <div className={css.sellerFeeImg}>
            <img src={sellerFee} alt="sellerFee" />
          </div>
        </div>
      </div>
    </div>
  );
}

SectionSellers.propTypes = {
  intl: intlShape.isRequired,
};

export default SectionSellers;